(() => {
  const URL_PARAM_DELIMITER = ';';

  class Addon {
    constructor(trigger) {
      this.trigger = trigger;

      if (!(this.trigger instanceof HTMLInputElement)) {
        console.error('HrefOps js plugin: trigger property or type HTMLInputElement is required');
        return;
      }

      if (!this.trigger.dataset || !this.trigger.dataset.targetSelector) {
        console.error('Addon plugin: [data-target-selector] attribute with the anchor element selector is required for element:', this.trigger);
        return;
      }

      const targetSelector = this.trigger.dataset.targetSelector;

      this.targetAnchors = document.querySelectorAll(targetSelector);

      if (this.targetAnchors.length === 0) {
        console.error(`Addon plugin: target element with selector "${targetSelector}" not found`, this.trigger);
        return;
      }

      this.targetAnchors.forEach(targetAnchor => {
        if (!(targetAnchor instanceof HTMLAnchorElement)) {
          console.error('Addon plugin: target elements are expected to be of type HTMLAnchorElement:', targetAnchor);
          return;
        }
      });

      this.param = this.trigger.dataset.parameter;
      this.value = this.trigger.dataset.value;

      this.price = parseFloat(this.trigger.dataset.addonPrice);
      this.priceElementsSelector = this.trigger.dataset.priceElementsSelector;

      if (this.priceElementsSelector && !this.price) {
        console.error('Addon plugin: [data-addon-price] attribute is expected with a valid integer price for element:', this.trigger);
        return;
      }

      if (this.price && !this.priceElementsSelector) {
        console.error('Addon plugin: [data-price-elements-selector] attribute is expected with a valid selector string for element:', this.trigger);
        return;
      }

      this.findPriceElements();

      const countElementsSelector = this.trigger.dataset.countElementsSelector;

      if (countElementsSelector) {
        this.countElements = document.querySelectorAll(countElementsSelector);

        if (this.countElements.length === 0) {
          console.error(`Addon plugin: Could not find addon count elements with selector: "${countElementsSelector}" configured at element:`, this.trigger);
          return;
        }
      }

      this.trigger.addEventListener('change', this.handleAddonChange.bind(this));
      this.updateCount();
    }

    static formatPrice(value) {
      return new Intl.NumberFormat('en-US').format(value);
    }

    findPriceElements() {
      if (!this.priceElementsSelector) return;

      this.priceElements = document.querySelectorAll(this.priceElementsSelector);

      if (this.priceElements.length === 0) {
        console.error(`Addon plugin: Could not find price elements with selector: "${this.priceElementsSelector}" configured at element:`, this.trigger);
      }
    }

    handleAddonChange() {
      this.toggleQueryParam();
      this.findPriceElements();
      this.updatePrice();
      this.updateCount();
    }

    updateCount() {
      if (!this.countElements) return;

      this.countElements.forEach(countElement => {
        const parsed = parseInt(countElement.innerHTML);
        const currentCount = Number.isInteger(parsed) ? parsed : 0;
        const count = this.trigger.checked ? currentCount + 1 : Math.max(0, currentCount - 1);
        countElement.parentElement.hidden = count === 0;

        countElement.innerHTML = count === 1 ? `${count} Add-on` : `${count} Add-ons`;
      });
    }

    updatePrice() {
      if (!this.priceElementsSelector || !this.priceElements) return;

      this.priceElements.forEach(priceElement => {
        const price = parseFloat(priceElement.dataset.price);

        if (!price) {
          console.error('Addon plugin: In order to update price with addon, [data-price] attribute is expected on element:', priceElement);
          return;
        }

        let newPrice = price;

        if (this.trigger.checked) {
          newPrice += this.price;
        }
        else {
          newPrice -= this.price;
        }

        priceElement.dataset.price = newPrice;
        priceElement.innerHTML = Addon.formatPrice(newPrice);
      });
    }

    addParam(searchParams, param, value) {
      if (searchParams.has(param)) {
        const currentValue = searchParams.get(param);
        const newValue = [currentValue, value].join(URL_PARAM_DELIMITER);
        searchParams.set(param, newValue);
        return;
      }

      searchParams.set(param, value);
    }

    deleteParam(searchParams, param, value) {
      const currentValue = searchParams.get(param);
      if (!currentValue) return;

      if (searchParams.has(param) && currentValue !== this.value) {
        const newValue = currentValue.split(URL_PARAM_DELIMITER).filter(x => x !== this.value).join(URL_PARAM_DELIMITER);
        searchParams.set(param, newValue);
        return;
      }

      searchParams.delete(param);
    }

    toggleQueryParam() {
      const checked = this.trigger.checked;

      this.targetAnchors.forEach(targetAnchor => {
        const url = new URL(targetAnchor.getAttribute('href'), window.location.href);

        if (this.trigger.checked) {
          this.addParam(url.searchParams, this.param, this.value);
        }
        else {
          this.deleteParam(url.searchParams, this.param, this.value);
        }

        // Preserve original relativeness when possible
        targetAnchor.href = url.origin === window.location.origin
          ? url.pathname + url.search + url.hash
          : url.toString();
      });
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ipswitch-plugin="addon"]').forEach(element => new Addon(element));
  });
})();
